interface AppConfig {
    nodeapiUrl: string,
    userbucket:string,
    launchpadcdn:string,
    launchpadwebcdn:string,
    urls: string
}

export const APP_CONFIG: AppConfig = {
    //'nodeapiUrl': "http://localhost:3000/digitalresources",
  	'nodeapiUrl': "https://betanodeapi.classlink.com/digitalresources",
  	//'nodeapiUrl': "https://nodeapi.classlink.com/digitalresources",
  	'userbucket': '//dlkf6mjgds3hc.cloudfront.net',
  	'launchpadcdn': "//dp3vjvsy1r9i0.cloudfront.net",
  	'launchpadwebcdn': "//d39we02312j3cg.cloudfront.net",
    'urls': 'https://betalaunchpad.classlink.com'
    //'urls': 'http://172.29.36.98:8080'
};
